import { z } from "zod";

export const formSearchParamsSchema = z.object({
    entry_id: z.string().uuid(),
    profile_id: z.string().uuid(),
});

export type FormSearchParams = z.infer<typeof formSearchParamsSchema>;
